export default "__VITE_ASSET__C$sNj0IU__"